import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import {FormControl} from "@material-ui/core";
import DataSelect from "../../../../../../../ui/DataSelect";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../ui/TextField";
import Attachments from "./Attachments";
import {loadDocTypeList} from "../../../../../../../Dict/DocType/View/fetch";
import ButtonDropDown from "../../../../../../../ui/ButtonDropDown";
import Box from "../../../../../../../ui/Box";
import ViewPageLayout from "../../../../../../../ui/ViewPageLayout";
import {getPersonAttachments, getPersonSnilsAttachments} from "../../../../store/actions";
import {addAttachments, addAttachmentsSnils} from "../../../../store/send";
import {deleteAttachment, deleteSnilsAttachment} from "../../../../store/deleteactions";
import Typography from "@material-ui/core/Typography";

const styles = () => ({
  container: {
    width: "100%",
    marginTop: "16px"
  },
  mainGrid:{
    marginTop: 8,
    marginBottom: 16
  }
});

const initialInfoDoc = {
  docType : null,
  series : "",
  number : "",
  date : "",
  issueOrgan : "",
  issueCode : ""
};

const Documents = ({  classes,
                     disabled,
                     editmode,
                     personId,
                     documentInfo,
                     onDocumentFormChange,
                     snilsNumber,
                     onSnilsChange,
                     loadDocTypeList, docTypeList,
                   categoryDocId,
                     addAttachments,
                     addAttachmentsSnils,
                     deleteAttachment,
                     deleteSnilsAttachment,
                     attachments, attachmentsSnils,
                     getPersonAttachments,
                     getPersonSnilsAttachments}) => {
  const [dataDoc, setDocData] = React.useState(documentInfo || initialInfoDoc);
  const [dataSnils, setDataSnils] = React.useState(snilsNumber || "");
  const [blockDocVisible, setBlockDocVisible] = React.useState(false);
  const [blockSnilsDocVisible, setBlockSnilsDocVisible] = React.useState(false);
  const { docType, series, number, date, issueOrgan, issueCode } = dataDoc;

  const onDocChange = (field, value) => {
    const newState = {
      ...dataDoc,
      [field]: value
    };

    setDocData(newState);
    onDocumentFormChange && onDocumentFormChange(newState);
  };

  const onSnilsDataChange = (value) => {
    setDataSnils(value);
    onSnilsChange && onSnilsChange(value);
  }

  React.useEffect(() => {
    if (categoryDocId) {
      loadDocTypeList(categoryDocId);
    }
  }, [categoryDocId]);

  const handleDocVisibleButton = () => {
    setBlockDocVisible(!blockDocVisible);
  }

  const handleSnilsDocVisibleButton = () => {
    setBlockSnilsDocVisible(!blockSnilsDocVisible);
  }

  return (
    <>
      <Box noMargin>
        <ViewPageLayout header="Документ, удостоверяющий личность">
          {dataDoc &&
          <Grid container spacing={1} className={classes.mainGrid}>
            <Grid item xs={6} md={3}>
              {docTypeList &&
              <DataSelect
                value={docType}
                onChange={value => onDocChange("docType", value.id)}
                label="Тип документа"
                dataSource={docTypeList}
                disableClearable={false}
                disabled={disabled || !editmode}
              />}
            </Grid>
            <Grid item xs={6} md={1}>
              <TextField
                value={series || ""}
                onChange={e => onDocChange("series", e.target.value)}
                label="Серия"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={2}>
              <TextField
                value={number || ""}
                onChange={e => onDocChange("number", e.target.value)}
                label="Номер"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <TextField
                value={issueOrgan || ""}
                onChange={e => onDocChange("issueOrgan", e.target.value)}
                label="Кем выдан"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={date || ""}
                onChange={e => onDocChange("date", e.target.value)}
                label="Дата выдачи"
                format="dd.MM.yyyy"
                type="date"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={issueCode || ""}
                onChange={e => onDocChange("issueCode", e.target.value)}
                label="Код подразделения"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <FormControl className={classes.container}>
                <ButtonDropDown caption="Скан документа"
                                onClick={handleDocVisibleButton}
                                arrowUp={blockDocVisible}/>
              </FormControl>
            </Grid>
          </Grid>}

          {blockDocVisible &&
            <Attachments title="Сканы документа, удостоверяющего личность"
                         editmode={editmode} personId={personId}
                         getAttachments={getPersonAttachments}
                         addAttachments={addAttachments}
                         deleteAttachment={deleteAttachment}
                         attachments={attachments}
            />
          }
        </ViewPageLayout>
      </Box>

      <Box noMargin style={{marginTop: 16}}>
        <ViewPageLayout style={{marginTop: "16px"}} header="СНИЛС">
          <Grid container spacing={1} className={classes.mainGrid}>
            <Grid item xs={6} md={3}>
              <TextField
                value={dataSnils || ""}
                onChange={e => onSnilsDataChange(e.target.value)}
                label="Номер"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <FormControl className={classes.container}>
                <ButtonDropDown caption="Скан СНИЛС"
                                onClick={handleSnilsDocVisibleButton}
                                arrowUp={blockSnilsDocVisible}/>
              </FormControl>
            </Grid>
          </Grid>

          {blockSnilsDocVisible &&
          <>
            <Attachments title="Сканы СНИЛС"
                         editmode={editmode} personId={personId}
                         getAttachments={getPersonSnilsAttachments}
                         addAttachments={addAttachmentsSnils}
                         deleteAttachment={deleteSnilsAttachment}
                         attachments={attachmentsSnils}/>
          </>
          }
        </ViewPageLayout>
      </Box>
      </>
  );
}

const mapStateToProps = state => ({
  docTypeList: state.dictDocTypeView.list,
  attachments: state.persons.attachments,
  attachmentsSnils: state.persons.attachmentsSnils
});

const mapDispatchToProps = dispatch => ({
  loadDocTypeList: (categoryId) => dispatch(loadDocTypeList(categoryId)),
  getPersonAttachments: () => dispatch(getPersonAttachments()),
  addAttachments: files => dispatch(addAttachments(files)),
  deleteAttachment: fileId => dispatch(deleteAttachment(fileId)),
  getPersonSnilsAttachments: () => dispatch(getPersonSnilsAttachments()),
  addAttachmentsSnils: files => dispatch(addAttachmentsSnils(files)),
  deleteSnilsAttachment: fileId => dispatch(deleteSnilsAttachment(fileId))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Documents));
